export default __webpack_public_path__ + "static/media/index-page.36d200d5.jpg";